import React, { useEffect } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { Footer, Header, defaultTheme } from '@compeon-os/components'
import { Helmet } from 'react-helmet'

import ErrorBoundary from './components/ErrorBoundary'
import { trackPageVisit, etmc } from 'helpers/tracking'
import Form from './components/Form'
import { env } from 'helpers/env'

const GTM_TOKEN = process.env.REACT_APP_GTM_TOKEN
const ETMC_TOKEN = process.env.REACT_APP_ETMC_TOKEN

const theme = {
  ...defaultTheme,
  inputCheckboxColor: defaultTheme.primaryColor,
}

const FooterWrapper = styled.div`
  bottom: 0;
  position: fixed;
  width: 100%;

  @media (min-width: 768px) {
    position: initial;
  }
`

const isStaging = env.isStaging()

const Tracking = () => (
  <Helmet>
    {GTM_TOKEN && [
      <script>
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_TOKEN}');`}
      </script>,
      <noscript>
        {`<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_TOKEN}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
      </noscript>
    ]}
    {ETMC_TOKEN && isStaging &&
     <script type="text/javascript" src={`//${ETMC_TOKEN}.collect.igodigital.com/collect.js`}></script>
    }
  </Helmet>
)

const Wrapper = styled.div`
  margin-bottom: 50px;
  max-width: 992px;

  @media (min-width: 768px) {
    & {
      margin: 0 auto;
    }
  }
`

const handleLogoClick = () => window.open('https://www.compeon.de')

function App() {
  useEffect(() => {
    trackPageVisit()
    setTimeout(() => {
      if (ETMC_TOKEN && isStaging) {
        etmc.initPageView()
        etmc.trackPageView()
      }
    }, !window._etmc ? 25 : 0)
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <Tracking />

        <Header hideUserInformation onLogoClick={handleLogoClick} />
        <Wrapper>
          <Form />
        </Wrapper>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
